import styled from '@emotion/styled';

const ReleaseWrapper = styled('article')({
  marginBottom: 16,
});

export default ReleaseWrapper;
